document.addEventListener('DOMContentLoaded', function () {
  if (window.__mtIniciado) return;
  window.__mtIniciado = true;
  initReveal();
  initGaleriaProducto();
  initContador();
  initSelectorVariantes();
  initAnadirAjax();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-mt-galeria]');
  if (!galeria) return;

  var principal = galeria.querySelector('[data-mt-imagen-principal]');
  var miniaturas = galeria.querySelectorAll('[data-mt-miniatura]');
  if (!principal || !miniaturas.length) return;

  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var nuevaUrl = mini.getAttribute('data-mt-full');
      if (!nuevaUrl) return;
      principal.src = nuevaUrl;
      miniaturas.forEach(function (m) { m.classList.remove('mt-miniatura-activa'); });
      mini.classList.add('mt-miniatura-activa');
    });
  });
}

function initSelectorVariantes() {
  var selects = document.querySelectorAll('.mt-opcion-select');
  var datosEl = document.querySelector('[data-mt-variantes]');
  if (!selects.length || !datosEl) return;

  var variantes;
  try {
    variantes = JSON.parse(datosEl.textContent);
  } catch (e) {
    return;
  }

  var inputId = document.querySelector('[data-mt-variant-id]');
  var precioEl = document.querySelector('[data-mt-precio]');
  var precioAntesEl = document.querySelector('[data-mt-precio-antes]');
  var boton = document.querySelector('[data-mt-boton-comprar]');
  var botonTexto = document.querySelector('[data-mt-boton-texto]');

  var todosLosSelects = document.querySelectorAll('.mt-opcion-select');

  function actualizar() {
    var valoresSeleccionados = [];
    todosLosSelects.forEach(function (s) { valoresSeleccionados.push(s.value); });

    var encontrada = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === valoresSeleccionados[i]; });
    });

    if (!encontrada) return;

    if (inputId) inputId.value = encontrada.id;
    if (precioEl) precioEl.textContent = formatearDinero(encontrada.price);

    if (precioAntesEl) {
      if (encontrada.compare_at_price && parseFloat(encontrada.compare_at_price) > parseFloat(encontrada.price)) {
        precioAntesEl.textContent = formatearDinero(encontrada.compare_at_price);
        precioAntesEl.style.display = '';
      } else {
        precioAntesEl.style.display = 'none';
      }
    }

    if (boton && botonTexto) {
      if (encontrada.available) {
        boton.disabled = false;
      } else {
        boton.disabled = true;
      }
    }
  }

  function formatearDinero(valor) {
    var numero = parseFloat(valor);
    if (window.Shopify && window.Shopify.formatMoney && window.moneyFormat) {
      return window.Shopify.formatMoney(numero * 100, window.moneyFormat);
    }
    return numero.toFixed(2);
  }

  todosLosSelects.forEach(function (s) {
    s.addEventListener('change', actualizar);
  });
}

function initContador() {
  var contadores = document.querySelectorAll('[data-mt-contador]');
  if (!contadores.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var final = parseFloat(el.getAttribute('data-mt-contador'));
      if (isNaN(final)) return;
      observer.unobserve(el);

      if (reduce) {
        el.textContent = final;
        return;
      }

      var inicio = 0;
      var duracion = 1400;
      var tInicio = null;

      function paso(timestamp) {
        if (!tInicio) tInicio = timestamp;
        var progreso = Math.min((timestamp - tInicio) / duracion, 1);
        var valor = Math.floor(progreso * (final - inicio) + inicio);
        el.textContent = valor;
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = final;
      }

      requestAnimationFrame(paso);
    });
  }, { threshold: 0.5 });

  contadores.forEach(function (el) { observer.observe(el); });
}

function initAnadirAjax() {
  var forms = document.querySelectorAll('.mt-producto-section form[action*="/cart/add"], .mt-cta-final-section form[action*="/cart/add"]');
  var notificacion = document.querySelector('cart-notification');
  if (!forms.length || !notificacion) return;

  forms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var boton = form.querySelector('[type="submit"]');
      if (boton) boton.disabled = true;

      var datos = new FormData(form);
      datos.append('sections', 'cart-notification-product,cart-notification-button,cart-icon-bubble');
      datos.append('sections_url', window.location.pathname);

      fetch(window.routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: datos })
        .then(function (r) { return r.json(); })
        .then(function (estado) {
          if (estado.status) { form.submit(); return; }
          notificacion.renderContents(estado);
        })
        .catch(function () { form.submit(); })
        .finally(function () { if (boton) boton.disabled = false; });
    });
  });
}
